import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { AnalyticsService, EventType } from '@yourcause/common/analytics';
import { TypeSafeFormBuilder, TypeSafeFormGroup } from '@yourcause/common/core-forms';
import { YCModalComponent } from '@yourcause/common/modals';
import { SystemTagsService } from '../system-tags.service';
import { SystemTags } from '../typings/system-tags.typing';
interface TagsFormGroup {
  tags: number[];
  newTagName: string;
}

@Component({
    selector: 'gc-manage-tags-modal',
    styleUrls: ['./manage-tags-modal.component.scss'],
    templateUrl: './manage-tags-modal.component.html',
    standalone: false
})
export class ManageTagsModalComponent extends YCModalComponent<number[]> implements OnInit {
  @Input() bucket: SystemTags.Buckets;
  @Input() subBucket: SystemTags.Buckets;
  @Input() currentTagIds: number[];
  @Input() isNomination = false;
  @Input() ids: number[];
  @Input() modalSubHeader: string;

  addingNewTag = false;
  isBulk = false;

  formGroup: TypeSafeFormGroup<TagsFormGroup>;
  allTags: {
    label: string;
    value: number;
  }[];

  constructor (
    private systemTagsService: SystemTagsService,
    private formBuilder: TypeSafeFormBuilder,
    private analyticsService: AnalyticsService
  ) {
    super();
  }

  async ngOnInit () {
    await this.systemTagsService.resolveSystemTags();
    this.isBulk = this.ids?.length > 1;
    this.currentTagIds = [
      ...this.currentTagIds
    ];
    this.allTags = this.systemTagsService.allTags.map(tag => ({
      label: tag.name,
      value: tag.id
    }));
    const tagIds = this.currentTagIds.map(tagId => {
      return this.allTags.find(tag => tag.value === tagId);
    }).map((tag) => tag && tag.value);
    this.formGroup = this.formBuilder.group<TagsFormGroup>({
      tags: [
        tagIds,
        this.tagsRequiredValidator()
      ],
      newTagName: ''
    });
  }

  tagsRequiredValidator () {
    return (control: AbstractControl) => {
      const noTagsSelected = control.value?.length === 0;
      const invalid = this.isBulk && noTagsSelected;
      if (invalid) {
        return {
          tagsRequired: {
            i18nKey: 'common:textMustSelectAtLeastOneTag',
            defaultValue: 'Must select at least one tag'
          }
        };
      }

      return null;
    };
  }

  handleSubmit () {
    this.closeModal.emit(this.formGroup.value.tags);
    this.analyticsService.emitEvent({
      eventName: 'Save manage tags',
      eventType: EventType.Click,
      extras: null
    });
  }

  handleCancel () {
    this.closeModal.emit();
  }
}
